/** Escala de gravidade visual — Cadeia de Ajuda (somente apresentação). */

export type CadeiaGravidade = 'normal' | 'atencao' | 'critico';

export const GRAVIDADE_LABEL: Record<CadeiaGravidade, string> = {
  normal: 'Normal',
  atencao: 'Atenção',
  critico: 'Crítico',
};

export interface CadeiaGravidadeStyle {
  label: string;
  rowBg: string;
  rowBorderLeft: string;
  chip: string;
  cellRing: string;
  badge: string;
  border: string;
  header: string;
}

export const GRAVIDADE_STYLE: Record<CadeiaGravidade, CadeiaGravidadeStyle> = {
  normal: {
    label: 'Normal',
    rowBg: '',
    rowBorderLeft: 'border-l-4 border-l-emerald-500',
    chip: 'border-slate-200 bg-white text-slate-600 dark:border-slate-700 dark:bg-slate-900/40 dark:text-slate-300',
    cellRing: '',
    badge: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-950/40 dark:text-emerald-300',
    border: 'border-slate-200 dark:border-slate-700',
    header: 'text-slate-500',
  },
  atencao: {
    label: 'Atenção',
    rowBg: 'bg-amber-50/40 dark:bg-amber-950/12',
    rowBorderLeft: 'border-l-4 border-l-amber-400',
    chip: 'border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-800 dark:bg-amber-950/30 dark:text-amber-200',
    cellRing: 'ring-1 ring-amber-400/70',
    badge: 'bg-amber-100 text-amber-800 dark:bg-amber-950/40 dark:text-amber-300',
    border: 'border-amber-300 dark:border-amber-800',
    header: 'text-amber-600 dark:text-amber-400',
  },
  critico: {
    label: 'Crítico',
    rowBg: 'bg-red-50/50 dark:bg-red-950/18',
    rowBorderLeft: 'border-l-4 border-l-red-500',
    chip: 'border-red-300 bg-red-50 text-red-700 dark:border-red-800 dark:bg-red-950/35 dark:text-red-200',
    cellRing: 'ring-2 ring-red-500/80',
    badge: 'bg-red-100 text-red-700 dark:bg-red-950/40 dark:text-red-300',
    border: 'border-red-400 dark:border-red-700',
    header: 'text-red-600 dark:text-red-400',
  },
};

const WEEKDAY_FULL = ['Domingo', 'Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sábado'];

/** Gravidade de um líder a partir do score já calculado. */
export function resolveLeaderGravidade(score: {
  severity: number;
  redDays: number;
  criticalLosses: number;
  perdidas: number;
  desvios: number;
  rotinasNaoRealizadas: number;
  aderenciaPct: number;
}): CadeiaGravidade {
  if (score.redDays > 0 || score.criticalLosses > 0 || score.perdidas >= 3) return 'critico';
  if (
    score.severity > 0 ||
    score.desvios > 0 ||
    score.perdidas > 0 ||
    score.rotinasNaoRealizadas > 0 ||
    score.aderenciaPct < 80
  ) {
    return 'atencao';
  }
  return 'normal';
}

/** Gravidade de um dia na matriz. */
export function resolveDayGravidade(nivel: 'verde' | 'laranja' | 'vermelho' | 'neutro'): CadeiaGravidade {
  if (nivel === 'vermelho') return 'critico';
  if (nivel === 'laranja') return 'atencao';
  return 'normal';
}

/** Gravidade do drawer a partir das métricas do dia. */
export function resolveDrawerGravidade(
  naoRealizado: number,
  desvio: number,
  hasCriticalLoss: boolean,
): CadeiaGravidade {
  if (naoRealizado > 0 || hasCriticalLoss) return 'critico';
  if (desvio > 0) return 'atencao';
  return 'normal';
}

export function weekdayLabelFromIso(iso: string): string {
  const [y, m, d] = iso.split('-').map(Number);
  return WEEKDAY_FULL[new Date(y, m - 1, d).getDay()];
}
